export const DEPART_CHILDREN = [
    { key: "DEPART_SIMPLE", label: "Départ" },
    { key: "DEPART_DC", label: "DC" },
    { key: "DEPART_HOSPITALISATION", label: "Hospitalisation" },
    { key: "DEPART_VACANCES", label: "Départ en vacances" },
];

export const ClassificationLabels = {
    URGENCE_CHRONIQUE:                  "Urgence chronique",
    URGENCE_CHRONIQUE_AJOUT_TTT:        "UC · Ajout TTT",
    URGENCE_CHRONIQUE_MODIF:            "UC · Modif",
    URGENCE_CHRONIQUE_DOSAGE:           "UC · Dosage",
    URGENCE_CHRONIQUE_MODIF_POSOLOGIE:  "UC · Modif posologie",
    DEPART_DC: "Départ · DC",
    DEPART_HOSPITALISATION: "Départ · Hospitalisation",
    DEPART_VACANCES: "Départ · Départ en vacances",
    DEPART_SIMPLE: "Départ",
    NOUVEL_ENTRANT: "Nouvel entrant / Retour d'hospitalisation",
    URGENCE_AIGUE: "Urgence aigue (< 28 jours)",
    CNO_ORTHO_CONTENTION: "CNO, ortho, contentions",
    STUP: "STUP",
    INFO_ADMIN: "Info admin",
    RENOUVELLEMENT: "Renouvellement",
    PAS_DE_MODIF_NOUVELLE_ORDO: "Pas de modif / nouvelle ordo",
    PRIMO_MISE_EN_ATTENTE: "Pas de modif / nouvelle ordo",
    LISTE_HP: "Liste HP",
    RAS_ANCIENNE_ORDO: "RAS/Ancienne ordo",
    RAS_NOUVELLE_ORDO: "Pas de modif / nouvelle ordo",
    DEMANDE_EHPAD: "Demande ehpad / Dotation ehpad",
    UNKNOWN: "-"
};

export const ClassificationValues = Object.fromEntries(
    Object.entries(ClassificationLabels).map(([key, label]) => [key, label])
);
